// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__FJi59","buttons":"PendingPaymentAlert_buttons__yKnMT"};